<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt from "@/http/requests/auth/jwt/index.js"
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'


export default {
  data() {
    return {
      vueAppClasses: [],
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    checkTokenExpiration() {
      let needAuth = this.$route.meta.needAuth
        ? this.$route.meta.needAuth
        : false;
      if(needAuth) {

        let tokenExpiry = localStorage.getItem("tokenExpiry")

        if(tokenExpiry){
           var tokenExpiryTime = new Date(tokenExpiry);
  
            if(tokenExpiryTime < new Date()) {
              localStorage.clear();
              this.$router.push("/login");

              this.$vs.notify({
                title: "Login Time Expired",
                text: "Please relogin with your credentials",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger"
              });
            }
        }
        else {
          this.$router.push("/login");
        }
      }
      else{
        // this.$vs.notify({
        //     title: "Login Time Expired",
        //     text: "Please relogin with your credentials",
        //     iconPack: "feather",
        //     icon: "icon-alert-circle",
        //     color: "danger"
        //   });
        //   this.$router.push("/login");
      }
    },
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  async mounted() {
    
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async updated() {
    await this.checkTokenExpiration();
  },
  async created() {

    // jwt
    jwt.init()
    

    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    // await this.$store.dispatch("userManagement/fetchStudents")
    // await this.$store.dispatch("userManagement/fetchTeachers")
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>
